import { render, staticRenderFns } from "./SouvenirProductsPage.vue?vue&type=template&id=006aed6e&scoped=true&"
import script from "./SouvenirProductsPage.vue?vue&type=script&lang=js&"
export * from "./SouvenirProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./SouvenirProductsPage.vue?vue&type=style&index=0&id=006aed6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006aed6e",
  null
  
)

export default component.exports